export const UPDATE_OPEN_PROCESS_STATEMENT_REQUEST = 'UPDATE_OPEN_PROCESS_STATEMENT_REQUEST';

export const updateOpenProcessStatementRequest = ( id, formData ) => ({
    type: UPDATE_OPEN_PROCESS_STATEMENT_REQUEST,
    payload: { id, formData  }
});
